<template>
    <div>
        <div class="searchbox row__start">
            <input
                type="text"
                v-model="companyName"
                placeholder="Suche nach Name des Unternehmens"
                @keyup="
                    getAvailableCompanies({
                        occupationId: selectedOccupation.id,
                        offerId: selectedOffer.id,
                        filterText: companyName,
                        exhibitionFilter: selectedExhibition,
                    })
                "
            />
            <SearchSvg />
        </div>
        <p class="text__primary m-15">oder</p>
        <div class="searchbox row__start searchbox--select">
            <input
                type="text"
                readonly
                v-model="selectedOccupation.name"
                placeholder="Suche über Berufsfelder"
            />
        </div>
        <SelectBox
            classes="selectbox--big"
            area="occupation"
            :options="occupationOptions"
            :selectedId="selectedOccupation.id"
            @click="setSelectOption"
        />
        <div class="searchbox row__start searchbox--select mt-15">
            <input
                type="text"
                readonly
                v-model="selectedOffer.name"
                placeholder="Angebot auswählen"
            />
        </div>
        <SelectBox
            :options="offerOptions"
            area="offer"
            :selectedId="selectedOffer.id"
            @click="setSelectOption"
        />
        <div class="searchbox mt-15" v-if="fair != null">
            <CheckBox
                :active="selectedExhibition"
                :text="'Nimmt an der Veranstaltung ' + getFairName() + ' teil'"
                :id="'exhibition'"
                :style="'width:100%; height:100%'"
                @click="toggleExhibitionFilter"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "HomeFilterCompanies",
    data() {
        return {
            selectedOccupation: { id: null, name: "" },
            selectedOffer: { id: null, name: "" },
            companyName: "",
            selectedExhibition: false,
        };
    },
    methods: {
        ...mapActions(["getAvailableCompanies"]),
        setSelectOption(option) {
            let reload = false;
            if (option.area == "offer") {
                if (this.selectedOffer.id != option.id) {
                    reload = true;
                }
                if (option.id == null) {
                    this.selectedOffer = { id: null, name: "" };
                } else {
                    this.selectedOffer = option;
                }
            } else if (option.area == "occupation") {
                if (this.selectedOccupation.id != option.id) {
                    reload = true;
                }
                if (option.id == null) {
                    this.selectedOccupation = { id: null, name: "" };
                } else {
                    this.selectedOccupation = option;
                }
            }
            if (reload) {
                this.getAvailableCompanies({
                    occupationId: this.selectedOccupation.id,
                    offerId: this.selectedOffer.id,
                    filterText: this.companyName,
                    exhibitionFilter: this.selectedExhibition,
                });
            }
        },
        toggleExhibitionFilter() {
            this.selectedExhibition = !this.selectedExhibition;
            sessionStorage.selectedExhibition = this.selectedExhibition;
            this.getAvailableCompanies({
                occupationId: this.selectedOccupation.id,
                offerId: this.selectedOffer.id,
                filterText: this.companyName,
                exhibitionFilter: this.selectedExhibition,
            });
        },
        getFairName() {
            return this.fair != null ? this.fair.name : "";
        },
    },
    watch: {
        selectedOccupation(selOcc) {
            sessionStorage.occupationId = selOcc.id;
            sessionStorage.occupationName = selOcc.name;
        },
        selectedOffer(selOff) {
            sessionStorage.offerId = selOff.id;
            sessionStorage.offerName = selOff.name;
        },
    },
    created() {
        if (sessionStorage.occupationId) {
            this.selectedOccupation.id = sessionStorage.occupationId;
            this.selectedOccupation.name = sessionStorage.occupationName;
        }
        if (sessionStorage.offerId) {
            this.selectedOffer.id = sessionStorage.offerId;
            this.selectedOffer.name = sessionStorage.offerName;
        }
        if (sessionStorage.selectedExhibition) {
            this.selectedExhibition =
                sessionStorage.selectedExhibition == "true";
        }
        // Check for query param ("deep link")
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        if (params.exhibitionFilter) {
            this.selectedExhibition = true;
            sessionStorage.selectedExhibition = true;
        }
        this.getAvailableCompanies({
            occupationId: this.selectedOccupation.id,
            offerId: this.selectedOffer.id,
            filterText: this.companyName,
            exhibitionFilter: this.selectedExhibition,
        });
    },
    computed: {
        ...mapGetters(["offerOptions", "occupationOptions", "fair"]),
    },
};
</script>
